import React, { Fragment, useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { LoadingComponent } from 'recupero-comunes'
import GrillaPrevImplicadosHistorial from './grillaPrevImplicadosHistorial'
import Previsiones from './previsiones'
import { useDispatch, useSelector } from 'react-redux'
import { configuracionFormAction39, obtenerCoberturaProvisiones, obtenerComboInstanciaPrevisiones, obtenerComboMonedas, obtenerProvisionesVigentes,
   obtenerComboResponsabilidadAsegurado, obtenerAmparosCia } from '../../../../store/actions/gestion-defensa-action'
import { Auth } from 'recupero-comunes';


const PrevisionesModal = ({ showPrevisiones, handleClosePrevisiones, showImplicados, setShowImplicados, showImplicadosHistorial, setShowImplicadosHistorial, modalAction, inprocess, implSeleccionado }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const data_gestion_defensa = useSelector((state) => state.gestionDefensaReducer);
  const { llaves, datosGestionImplicado } = data_gestion_defensa;

  useEffect(() => {
    if (showPrevisiones && llaves && datosGestionImplicado) {

      setLoading(true)

      let query = Buffer.from(JSON.stringify({ rutcia: llaves && llaves['idOrgCaso'], idform: 40 })).toString('base64')
      dispatch(configuracionFormAction39(query));

      const paisOrganizacion = Auth.currentUser().paisOrganizacion;
      const codClasCaso = datosGestionImplicado.datosGestionImplicado && datosGestionImplicado.datosGestionImplicado.length > 0 && datosGestionImplicado.datosGestionImplicado[0].codClasCaso;
      const query_one = Buffer.from(JSON.stringify({ pais: paisOrganizacion, clasBien: codClasCaso })).toString('base64');
      dispatch(obtenerComboMonedas(query_one))
      .then(() => {
        let query = Buffer.from(JSON.stringify({ concepto: 263 })).toString('base64')
        dispatch(obtenerComboInstanciaPrevisiones(query))
      })
      .then(() => {
        let query = Buffer.from(JSON.stringify({ concepto: 309 })).toString('base64')
        dispatch(obtenerComboResponsabilidadAsegurado(query))
      })
      

      if (!inprocess) {        
        let query = Buffer.from(JSON.stringify({
          idCaso: llaves && llaves['idCaso'], //127,
          idImplicado: llaves && llaves['idImplicado'],
          tipoGestion: datosGestionImplicado.datosGestionImplicado && datosGestionImplicado.datosGestionImplicado.length > 0 && datosGestionImplicado.datosGestionImplicado[0].codTipoGestion,
          tipoMovimiento: modalAction === "button" ? 261002 : 261003,
          situacion: "245002, 245005",
        })).toString('base64')

        dispatch(obtenerProvisionesVigentes(query))
        .then(() => {
          let query = Buffer.from(JSON.stringify({
            idCaso: llaves && llaves['idCaso'], //115,
            idImplicado: llaves && llaves['idImplicado'],
            tipoGestion: datosGestionImplicado.datosGestionImplicado && datosGestionImplicado.datosGestionImplicado.length > 0 && datosGestionImplicado.datosGestionImplicado[0].codTipoGestion,
            tipoMovimiento: 999,
            situacion: 999
          })).toString('base64')
          dispatch(obtenerCoberturaProvisiones(query))
        })
        .then(() => {
          let query = Buffer.from(JSON.stringify({
            idCaso: llaves && llaves['idCaso'], //127,
            idImplicado: llaves && llaves['idImplicado'],
            tipoGestion: datosGestionImplicado.datosGestionImplicado && datosGestionImplicado.datosGestionImplicado.length > 0 && datosGestionImplicado.datosGestionImplicado[0].codTipoGestion,
            tipoMovimiento: 261002,
            situacion: "245002, 245005",
          })).toString('base64')
          dispatch(obtenerAmparosCia(query))
        })          
        .then(() => setLoading(false));
      } else {
        setLoading(false)
      }
    }
  }, [llaves, showPrevisiones])

  return (
    <Fragment>
      <LoadingComponent show={loading} />
      <Modal show={showPrevisiones} onHide={handleClosePrevisiones} size='xl'>
        <Previsiones
          handleClose={handleClosePrevisiones}
          setShowImplicados={setShowImplicados}
          setShowImplicadosHistorial={setShowImplicadosHistorial}
          action={modalAction}
          inprocess={inprocess}
          implSeleccionado={implSeleccionado}
        />
        {showImplicadosHistorial &&
          <GrillaPrevImplicadosHistorial
            inprocess={inprocess}
            handleClose={handleClosePrevisiones}
            action={modalAction}
          />
        }
      </Modal>
    </Fragment>
  )
}

export default PrevisionesModal
